module.exports = __webpack_public_path__ + "static/media/write-document.32893a72.svg";